import {useState} from "react";
import {Button, Col, Divider, Modal, Row, Space, Spin, Upload} from "antd";
import i18next from "i18next";
import {CheckCircleFilled, CloudUploadOutlined, ExclamationCircleFilled} from "@ant-design/icons";
import * as OrganizationBackend from "../../services/OrganizationBackend";
import * as UserBackend from "../../services/UserBackend";
import * as Setting from "../../conf/Setting";
import {useHistory} from "react-router-dom";
import "../../assets/styles/user/UserImport.less";

export const UserImport = ({nodeData, visible, dismiss, type}) => {
  const [uploadState, setUploadState] = useState("preUpload");
  const [result, setResult] = useState(null);
  const history = useHistory();

  const uploadProps = {
    accept: ".xls,.xlsx",
    showUploadList: false,
    beforeUpload: async(file) => {
      setUploadState("uploadLoading");
      try {
        let res;
        if (type === "department") {
          res = await OrganizationBackend.importDepartment(file).then();
        } else {
          res = await UserBackend.importUser(file).then();
        }

        const ret = {};
        ret.status = res.status;
        if (res.status === "ok") {
          if (res.data.length > 1 && res.data[1] === 0) {
            ret.successfulCount = res.data[0];
            ret.failedCount = res.data[1];
            setUploadState("uploadSuccessfully");
            setResult(ret);
          } else {
            ret.successfulCount = res.data[0];
            ret.failedCount = res.data[1];
            ret.msg = i18next.t("import:Download the record file to check");
            ret.recordFilename = res.data2;
            setResult(res.data);
            setUploadState("uploadFailed");
            setResult(ret);
          }
        } else {
          ret.msg = Setting.getResponseMessage(res.msg);
          setUploadState("uploadFailed");
          setResult(ret);
        }
      } catch (error) {
        Setting.showResponseMessage(error);
        setUploadState("preUpload");
      }

      // if (type === "department") {
      //   OrganizationBackend.importDepartment(file)
      //     .then(res => {
      //       const ret = {};
      //       ret.status = res.status;
      //       if (res.status === "ok") {
      //         if (res.data.length > 1 && res.data[1] === 0) {
      //           ret.successfulCount = res.data[0];
      //           ret.failedCount = res.data[1];
      //           setUploadState("uploadSuccessfully");
      //           setResult(ret);
      //         } else {
      //           ret.successfulCount = res.data[0];
      //           ret.failedCount = res.data[1];
      //           ret.msg = i18next.t("import:Download the record file to check");
      //           ret.recordFilename = res.data2;
      //           setResult(res.data);
      //           setUploadState("uploadFailed");
      //           setResult(ret);
      //         }
      //       } else {
      //         ret.msg = Setting.getResponseMessage(res.msg);
      //         setUploadState("uploadFailed");
      //         setResult(ret);
      //       }
      //     }).catch(error => {
      //       Setting.showResponseMessage(error);
      //       setUploadState("preUpload");
      //     });
      // } else {
      //   UserBackend.importUser(file)
      //     .then(res => {
      //       const ret = {};
      //       ret.status = res.status;
      //       if (res.status === "ok") {
      //         if (res.data.length > 1 && res.data[1] === 0) {
      //           ret.successfulCount = res.data[0];
      //           ret.failedCount = res.data[1];
      //           setUploadState("uploadSuccessfully");
      //           setResult(ret);
      //         } else {
      //           ret.successfulCount = res.data[0];
      //           ret.failedCount = res.data[1];
      //           ret.msg = i18next.t("import:Download the record file to check");
      //           ret.recordFilename = res.data2;
      //           setResult(res.data);
      //           setUploadState("uploadFailed");
      //           setResult(ret);
      //         }
      //       } else {
      //         ret.msg = Setting.getResponseMessage(res.msg);
      //         setUploadState("uploadFailed");
      //         setResult(ret);
      //       }
      //     }).catch(error => {
      //       Setting.showResponseMessage(error);
      //       setUploadState("preUpload");
      //     });
      // }

      return false;
    },
  };

  const downloadTemplate = () => {
    if (type === "department") {
      OrganizationBackend.downloadDepartmentTemplate();
    } else {
      UserBackend.downloadUserTemplate();
    }
  };

  const downloadFailedRecord = (e) => {
    e.preventDefault();

    if (type === "department") {
      OrganizationBackend.downloadImportError(result.recordFilename);
    } else {
      UserBackend.downloadImportError(result.recordFilename);
    }
  };

  const uploadFileRow = () => {
    if (uploadState === "preUpload") {
      return <>
        <CloudUploadOutlined style={{display: "block", fontSize: 46, color: "#BBBBBB"}} />
        <Upload {...uploadProps}><a>{i18next.t("import:Click to Upload")}</a></Upload>
      </>;
    }
    if (uploadState === "uploadLoading") {
      return <>
        <Spin />
        <div>{i18next.t("import:Data Importing")}</div>
      </>;
    }
    if (uploadState === "uploadFailed") {
      return <>
        <ExclamationCircleFilled style={{fontSize: 48, color: "#EAB050", marginBottom: 10}} />
        <div> {result.status === "ok" ? i18next.t("import:Importing failed {successful count} {failed count}")
          .replace("{successful count}", result.successfulCount)
          .replace("{failed count}", result.failedCount) : i18next.t("import:Failed to import")}</div>
        <div style={{marginBottom: 20}}>{i18next.t("import:Import failed reason {reason}")
          .replace("{reason}", result.msg)}</div>
        <Space size={28}>
          <Upload {...uploadProps}>
            <Button type="primary" ghost style={{borderRadius: "2px"}}>{i18next.t("import:Upload Again")}</Button>
          </Upload>
          {result.status !== "ok" ? null : <Button style={{borderRadius: "2px"}} type="primary" onClick={downloadFailedRecord}>
            {i18next.t("import:Download failed records")}</Button>}
        </Space>
      </>;
    }
    if (uploadState === "uploadSuccessfully") {
      return <>
        <CheckCircleFilled style={{fontSize: 48, color: "#81D564"}} />
        <div>{i18next.t("import:Imported {successful count} rows Successfully").replace("{successful count}", result.successfulCount)}</div>
      </>;
    }
    return <></>;
  };

  return (
    <Row>
      <Modal
        maskClosable={false}
        destroyOnClose={true}
        title={type === "user" ? i18next.t("import:Import User") : i18next.t("import:Import Department")}
        visible={visible}
        footer={null}
        onCancel={() => {
          setUploadState("preUpload");setResult(null);dismiss();
          if (result?.successfulCount > 0) {
            // 有导入成功的记录，则刷新页面
            history.go(0);
          }
        }}
        width={560}
        className="modal-import-user"
      >
        <Row style={{height: 223}} align="middle">
          <Col style={{textAlign: "center"}} span={24}>
            {uploadFileRow()}
          </Col>
        </Row>
        <Divider style={{marginTop: 0, marginBottom: 12}} />
        <Row>
          <Col span={24} style={{paddingLeft: 32, paddingRight: 32, marginBottom: 30}}>
            <div>
              {i18next.t("import:Descriptions")}
            </div>
            <div>
							1.{i18next.t("import:Description1")}<a onClick={downloadTemplate}>{i18next.t("import:Importing Template")}</a>
            </div>
            <div>
							2.{i18next.t("import:Description2")}
            </div>
          </Col>
        </Row>
      </Modal>
    </Row>
  );
};

export default UserImport;
